function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), React.createElement("path", {
  d: "M2.357 13.737a8.03 8.03 0 0010.619.659l5.318 5.318a1 1 0 001.414-1.414l-5.318-5.318A8.04 8.04 0 002.357 2.36a8.042 8.042 0 000 11.376zm1.414-9.96A6.043 6.043 0 112 8.05a6 6 0 011.77-4.276v.002z",
  fill: "#000"
})));